import * as React from 'react';
import { type ComponentProps } from 'react';

import type { PageConfig_PageName as PageName } from '__generated__/graphql-types';

import ComponentsConfigProvider from 'bundles/page-config-common/providers/ComponentsConfigProvider';

type Props = ComponentProps<typeof ComponentsConfigProvider> &
  (
    | {
        pageName: typeof PageName.BrowseSkill;
        additionalInput: {
          skill_id: string;
          skill_name: string; // for compatibility reasons, we need skill_name (which is also the slug)
        };
      }
    | {
        pageName: typeof PageName.BrowseDomain;
        additionalInput: {
          domain_id: string;
          domain_name: string; // this is actually the "search topic" that the domain maps to
        };
      }
  );

const TypedComponentsConfigProvider = (props: Props) => {
  return <ComponentsConfigProvider {...props} />;
};

export default TypedComponentsConfigProvider;
